export default "__VITE_ASSET__CIUvvl0t__"